<template>
    <div class="filter-dialog">
        <div class="px-4 mb-3">
            <h2 class="filter-dialog__title pl-4"><slot name="title">{{ title }}</slot></h2>
            <template v-if="subtitle">
                <h3 class="filter-dialog__subtitle pl-4">{{ subtitle }}</h3>
            </template>
        </div>
        <slot />
        <div class="px-4">
            <div class="filter-dialog__footer mt-3">
                <div class="row justify-content-between">
                    <div class="col-auto">
                        <button class="btn btn-link" @click="handleResetButtonClicked">tout effacer</button>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-primary text-uppercase py-1" @click="handleSubmitButtonClicked">Valider</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                // required: true,
                type: String,
            },
            subtitle: String,
        },
        methods: {
            handleCloseClicked() {
                this.$emit('close');
            },
            handleResetButtonClicked() {
                this.$emit('reset');
            },
            handleSubmitButtonClicked() {
                this.$emit('submit');
            },
        }
    }
</script>